module.exports = __webpack_public_path__ + "static/media/drawResBg.fcc5b5b4.png";